import { useMemo } from "react";

import useGetStaffCourseExpectations from "~/pages/Editor/EditorStaff/hooks/useGetStaffCourseExpectations";

export const useSelectedPositionsCourses = (watch: any) => {
  const pos = watch("positions") || [];

  const positionsParams =
    pos.length > 0
      ? pos.map((id: number) => `positionIds[]=${id}`).join("&")
      : "";

  const { data: coursesData, isLoading } =
    useGetStaffCourseExpectations(positionsParams);

  const coursesOptions = useMemo(() => {
    if (!coursesData?.courses) return [];

    const uniqueCourses = coursesData.courses.filter(
      (course: any, index: number, self: any[]) =>
        index === self.findIndex((c) => c.instanceId === course.instanceId),
    );

    return uniqueCourses.map((course: any) => ({
      value: course.instanceId,
      label: `${course.codeIs} ${course.name}`,
    }));
  }, [coursesData]);

  return {
    coursesOptions,
    isLoading,
    isLoaded: !isLoading && coursesData !== undefined,
  };
};
